export const BYTE_TRIPWIRE = 10 * 1024 * 1024;

export const ROW_CAP = 5000;
